<template>
  <li class="suite-menu-mobile drop-down_menu" @click="toggle" :class="{'drop-open': active}">
    <a>{{ $t('topbar.menu.suites').toUpperCase() }}</a>
    <div class="drop-down_container">
      <div class="sub-menu">
        <ul class="nossuites">
          <li v-for="(zone, zoneIndex) in roomZones" :item="zone" :index="zoneIndex" :key="zone.name"
              class="li-zone">
            <div class="zone-header-mobile">
              <h3 v-on:click.stop="selectZone(zone.id)">{{ zone.name }}</h3>
            </div>
            <div class="catsuites-mobile" v-for="(group, groupIndex) in zone.room_groups" :item="group"
                 :index="groupIndex"
                 :key="group.text.name">
              <a class="cat" v-on:click.stop="selectGroup(zone.id, group.id)">{{ group.text.name }}</a>
              <router-link tag="a" :to="{name: 'room', params: {id: room.id, slug: slug(room.text.short_name)}}"
                           class="suite"
                           v-for="(room, roomIndex) in group.rooms" :item="room" :key="room.name"
                           :index="roomIndex">
                              <span class="pre-room" v-if="room.label && room.label.short">
                                <star-icon/>
                              </span>
                {{ room.text.short_name }}
              </router-link>
            </div>
          </li>
        </ul>
      </div>
    </div>
  </li>
</template>

<script>
import {mapState} from "vuex";
import {TextHelper} from "../../helpers/text.helper";
import StarIcon from "../star-icon";

export default {
  name: "suites-menu-mobile",
  components: {StarIcon},
  computed: {
    ...mapState({
      instagram: s => s.menu.instagram,
      articles: s => s.menu.blogArticles,
      roomZones: s => s.menu.roomZones,
    }),
    columnStyle() {
      return `grid-template-columns: repeat(${this.roomZones.length}, 1fr);`
    }
  },
  data() {
    return {
      active: false
    }
  },
  methods: {
    toggle(e) {
      this.active = !this.active;
    },
    close() {
      this.active = false;
    },
    slug(v) {
      return TextHelper.slugify(v);
    },
    async redirect (keeGroups = false) {
      if (this.$route.name === 'search') {
        this.$store.commit('search/AUTO_FILL');
        await this.$store.dispatch('search/process', {keepGroups: keeGroups, runAuto: true});
        return;
      }
      await this.$router.push({name: 'search', params: {runAuto: true}});
    },
    async selectZone(id) {
      this.close();
      this.$store.commit('search/SET_SEARCH_ZONE', id);
      return this.redirect();
    },
    async selectGroup(zone, id) {
      this.close();
      this.$store.commit('search/SET_SEARCH_ZONE', zone);
      this.$store.commit('search/SET_SEARCH_GROUP', [id]);
      return this.redirect(true);
    },
  },
}
</script>

<style scoped>
.suite {
  position: relative;
}

.pre-room {
  height: 12px;
  position: absolute;
  left: -18px;
}
</style>



// WEBPACK FOOTER //
// src/components/topbar/suites-menu-mobile.vue